module.exports = __webpack_public_path__ + "img/Austria.d45de22d.gif";